export default __webpack_public_path__ + "static/media/minting_progress_page_bg.2d7c481c.png";